// SPDX-License-Identifier: AGPL-3.0-or-later

import {Endpoints} from '@app/features/app/constants/Endpoints';
import {http} from '@app/features/platform/transport/RestTransport';
import type {
	PaddleBoostPreviewResponse,
	PaddleBoostQuantityRequest,
	PaddleBoostSubscriptionResponse,
	PaddleBoostSubscriptionState,
} from '@fluxer/schema/src/domains/premium/PaddleSubscriptionSchemas';

// The monthly boost subscription of this account: the server finds its own; no subscription id goes up.
export async function fetchBoostSubscription(): Promise<PaddleBoostSubscriptionResponse> {
	const response = await http.get<PaddleBoostSubscriptionResponse>(Endpoints.PADDLE_BOOST_SUBSCRIPTION);
	return response.body;
}

// Paddle's own numbers for a new quantity: what it charges today and every month after; nothing changes yet.
export async function previewBoostQuantity(quantity: number): Promise<PaddleBoostPreviewResponse> {
	const body: PaddleBoostQuantityRequest = {quantity};
	const response = await http.post<PaddleBoostPreviewResponse>(Endpoints.PADDLE_BOOST_SUBSCRIPTION_PREVIEW, {body});
	return response.body;
}

// chargeNow: the confirmed preview charged at once; the server refuses a change that would now do otherwise.
export async function changeBoostQuantity(quantity: number, chargeNow: boolean): Promise<PaddleBoostSubscriptionState> {
	const body: PaddleBoostQuantityRequest = {quantity, charge_now: chargeNow};
	const response = await http.patch<PaddleBoostSubscriptionState>(Endpoints.PADDLE_BOOST_SUBSCRIPTION, {body});
	return response.body;
}

export async function cancelBoostSubscription(): Promise<PaddleBoostSubscriptionState> {
	const response = await http.post<PaddleBoostSubscriptionState>(Endpoints.PADDLE_BOOST_SUBSCRIPTION_CANCEL);
	return response.body;
}

export async function reactivateBoostSubscription(): Promise<PaddleBoostSubscriptionState> {
	const response = await http.post<PaddleBoostSubscriptionState>(Endpoints.PADDLE_BOOST_SUBSCRIPTION_REACTIVATE);
	return response.body;
}

// A payment page made for this request only; it is opened and never kept.
export async function createBoostPaymentMethodUrl(): Promise<string> {
	const response = await http.post<{url: string}>(Endpoints.PADDLE_BOOST_SUBSCRIPTION_PAYMENT_METHOD);
	return response.body.url;
}
